import React from "react";
import PropTypes from "prop-types";

const DashboardPanel = ({ title, icon, action, children }) => (
    <div className="dashboard-detail-card">
        <div className="dashboard-card-header">
            <span className="dashboard-card-title">
                {icon}
                {title}
            </span>
            {action}
        </div>
        {children}
    </div>
);

DashboardPanel.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    action: PropTypes.node,
    children: PropTypes.node.isRequired
};

DashboardPanel.defaultProps = {
    icon: null,
    action: null
};

export default DashboardPanel;
